<template>
  <div class="notification-batch-volunteers">
    <ag-table :data-source-api="getAllBatchVolunteers" :grid-options="gridOptions" :permissions="permissions"
      :rtl="false" :is-entities-response="false" />
  </div>
</template>

<script>
import AgTable from '../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import { RepositoryFactory } from '../volunteer-repositories/volunteerRepositoryFactory';

const volunteerRepo = RepositoryFactory.get('volunteerRepository');

export default {
  name: "NotificationBatchVolunteers",
  components: {
    AgTable,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      gender: {
        male: 'ذكر',
        female: 'انثى',
      },
      permissions: {},
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'معرف المتطوع',
          field: 'id',
          sortable: true,
          suppressSizeToFit: true,
          width: 200,
        },
        {
          headerName: 'الاسم',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
        {
          headerName: 'رقم الموبايل',
          field: 'phoneNumber',
          filter: 'agTextColumnFilter',
          width: 210,
          sortable: false,
        },
      ];
    },
    async getAllBatchVolunteers(query) {
      const id = this.$route.params.id;
      return await volunteerRepo.fetchNotificationBatchVolunteers(id, query);
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>
